module.exports = __webpack_public_path__ + "static/ume04-fc200e181d3ad736d0a89a48b4ecf619.png";